<script>
  import DashboardLeftPanel from '../components/DashboardLeftPanel.svelte';
  import DashboardRightPanel from '../components/DashboardRightPanel.svelte';
  let dashboardLeftObj;
</script>

<div class="d-flex flex-row h-100">
  <DashboardLeftPanel bind:this={dashboardLeftObj} />
  <DashboardRightPanel dashboardLeftObj={dashboardLeftObj} />
</div>
